/**
 * 本下级
 */
export const CURRENT_AND_SUBORDINATE = 'current_and_subordinate'

/**
 * 本级
 */
export const CURRENT = 'current'

/**
 * 下级
 */
export const SUBORDINATE = 'subordinate'
